// Components
import { TimeSection } from '@/components/pages/giveaway-picker/OptionsWrapper/components/Deadline/TimeSection';
import { TimezoneSection } from '@/components/pages/giveaway-picker/OptionsWrapper/components/Deadline/TimezoneSection';

export const TimeAndTimezoneSection = () => (
    <span className="flex w-full gap-3 sm:w-2/3">
        <TimeSection />
        <TimezoneSection />
    </span>
);
